import { types } from '@/modules/administrace/provozovna/store/types';
import { cellNames, columnsToCamelCase, Table } from '@/main/utils/table';
import { Status } from '@/main/store/@types/page';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';
import { EditStore, EditStoreProps } from '@/main/store/@types/edit.d';

import { Edit, LocalState, ProvozovnaDropdownList } from './state';

type State = EditStore<Edit, ProvozovnaDropdownList, LocalState, {}, EditStoreProps>;

type Data = { data?: any, tableName?: string, loadingCount?: number };

export const mutations = {
	[types.mutations.DODAVATEL_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.DodavatelId = data.value;
		state.edit.DodavatelIdText = data.text;
	},
	[types.mutations.DEALERKVPS_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.OrgUnitId = data.value;
		state.edit.DealerKvpsCode = data.text;
	},
	[types.mutations.PRIMARY_BANK_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.BankucetId = data.value;
		state.edit.BankucetIdText = data.text;
		state.edit.BankaUcet = data.BANKA_UCET;
		state.edit.BankaIban = data.BANKA_IBAN;
		state.edit.BankaBic = data.BANKA_BIC;
		state.edit.BankucetId2 = data.value;
		state.edit.BankucetId2Text = data.text;
		state.edit.BankaUcet2 = data.BANKA_UCET;
		state.edit.BankaIban2 = data.BANKA_IBAN;
		state.edit.BankaBic2 = data.BANKA_BIC;
	},
	[types.mutations.SECONDARY_BANK_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.BankaUcet2 = data.BANKA_UCET;
		state.edit.BankaIban2 = data.BANKA_IBAN;
		state.edit.BankaBic2 = data.BANKA_BIC;
		state.edit.BankucetId2 = data.value;
		state.edit.BankucetId2Text = data.text;
	},
	[types.mutations.INTR_ZAKAZNIK_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.IntrZakaznikId = data.value;
		state.edit.IntrZakaznikIdText = data.text;
	},
	[types.mutations.FN1_DODAVATEL_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.ApGdId = data.value;
		state.edit.ApGdIdText = data.text;
	},
	[types.mutations.INTERNI_DRUH_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.IntrDruhOzn = data.IntrDruhOzn;
		state.edit.IntrDruhOznText = data.IntrDruhOznText;
	},
	[types.mutations.SKLAD_PREVOD_INTERNI_DRUH_SELECT_MAPPER](state: State, { data }: Data) {
		state.edit.SkladPrevodIntrDruhOzn = data.IntrDruhOzn;
		state.edit.SkladPrevodIntrDruhOznText = data.IntrDruhOznText;
	},
	[types.mutations.SET_PROVOZOVNA_TABLE](state: State, { data, tableName }: Data) {
		const table = (state.localState as Record<string, any>)[`${tableName}Table`] || new Table();
		table.columns = columnsToCamelCase(data.Columns);
		table.cellNames = cellNames(table);
		table.operations = data.Operations;
		table.hasIdColumn = data.HasIdColumn;
		table.status = Status.ok;
		table.rows = data.Rows.map((row: any) => objectToCamelCaseShallow(row));
		if (!(state.localState as Record<string, any>)[`${tableName}Table`]) {
			(state.localState as Record<string, any>)[`${tableName}Table`] = table;
		}
	},
};
